// extracted by mini-css-extract-plugin
export var bgImage = "Intro-module--bgImage--987d0";
export var content = "Intro-module--content--c5493";
export var rabbit = "Intro-module--rabbit--a5ff6";
export var redCircle = "Intro-module--redCircle--304e2";